// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace StringUtil {
	export const nameOf = <T>(name: keyof T) => name.toString().toLowerCase();
}
